import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { resolveAccessibleLandingPath } from 'access/routeAccess';
import { usePermissions } from 'access/usePermission';
import {
  consumePostLoginRedirectForKey,
  isSafeInternalPath,
} from 'utils/postLoginRedirect';

type PostLoginOrDefaultRedirectProps = {
  defaultPath: string;
};

/**
 * After auth, `/` resolves here: pending sessionStorage redirect or first route
 * the user may access (sidebar order). `/dashboard` is only used when nothing
 * is granted.
 */
export default function PostLoginOrDefaultRedirect({
  defaultPath,
}: PostLoginOrDefaultRedirectProps) {
  const { key } = useLocation();
  const { can } = usePermissions();
  const pending = consumePostLoginRedirectForKey(key);
  const target = resolveAccessibleLandingPath(can, [
    ...(pending ? [pending] : []),
    defaultPath,
  ]);
  const safeTarget = isSafeInternalPath(target.split('?')[0].split('#')[0])
    ? target
    : '/dashboard';
  return <Navigate to={safeTarget} replace />;
}
